import React from 'react';

/**
 * ProgramsErrorBoundary
 * 
 * Wraps MyPrograms. If any render error occurs (e.g. _document chain crash
 * on iOS from stale localStorage data), shows a recovery screen instead of
 * a white screen. On recovery tap, clears the bad Program cache and reloads.
 */
class ProgramsErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true, error };
    }

    componentDidCatch(error, info) {
        console.error('ProgramsErrorBoundary caught a render error:', error, info);
    }

    handleRetry = () => {
        // ✅ Clear the bad cached program data so Index.js re-fetches clean on next load
        localStorage.removeItem('Program');
        this.setState({ hasError: false, error: null });
        // Force a full reload so Index.js re-runs and re-normalizes fresh data
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '80vh',
                    padding: '24px',
                    textAlign: 'center',
                    fontFamily: 'Rajdhani, sans-serif',
                }}>
                    <div style={{ fontSize: '48px', marginBottom: '16px' }}>⚠️</div>
                    <div style={{ fontSize: '20px', fontWeight: '700', color: '#2D2F35', marginBottom: '8px' }}>
                        Couldn't load programs
                    </div>
                    <div style={{ fontSize: '14px', color: '#6E7382', marginBottom: '32px', lineHeight: '1.5' }}>
                        There was a problem loading your programs.{'\n'}Tap below to refresh.
                    </div>
                    <button
                        onClick={this.handleRetry}
                        style={{
                            backgroundColor: '#3974E5',
                            color: '#fff',
                            border: 'none',
                            borderRadius: '12px',
                            padding: '14px 32px',
                            fontSize: '16px',
                            fontWeight: '700',
                            cursor: 'pointer',
                            width: '80%',
                            maxWidth: '300px',
                        }}
                    >
                        Retry
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ProgramsErrorBoundary;